import React, { forwardRef } from "react";
import { useRecoilValue } from "recoil";
import { NumericFormatProps, NumberFormatBase } from "react-number-format";
import { propertyFormatterService } from "../../NumberFormatter";

interface CustomProps {
  onChange: (event: { target: { value: string } }) => void;
  name: string;
}

/**
 * Input transform number to currency format
 */
const CurrencyFormatInput = forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const formatter = useRecoilValue(propertyFormatterService);
    const { onChange, ...other } = props;

    const format = (numStr: string) => {
      if (numStr === "") return "";
      return formatter.format(Number(numStr), {
        style: "currency",
        maximumFractionDigits: 0,
      });
    };

    return (
      <NumberFormatBase
        {...other}
        getInputRef={ref}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        format={format}
        valueIsNumericString
      />
    );
  }
);

export default CurrencyFormatInput;
